// extracted by mini-css-extract-plugin
export var card = "_4o-0";
export var content = "_4o-1";
export var contentLoading = "_4o-2";